// NOTE: DO NOT REMOVE ".toString()", condition won`t work without it here
if (process.env.SENTRY_ENABLED.toString() === 'true' &&
    (process.env.APP_ENV.toString() === 'prod' || process.env.APP_ENV.toString() === 'docker_dev')) {
  // Require need to be inside condition due everytime import in main.js and build error
  const Sentry = require('@sentry/browser')

  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.SENTRY_ENV || 'N/A',
    release: process.env.SENTRY_RELEASE || 'N/A',
    // authToken: process.env.SENTRY_AUTH_TOKEN || undefined,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: process.env.APP_ENV.toString() !== 'prod' ? 0.5 : 1.0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      // NOTE: produce browser error
      // {"detail": "Cannot parse request body"}, payload finish with "íW®³ñoÖúÀìólè"
      // Sentry.replayIntegration()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: process.env.APP_ENV.toString() !== 'prod' ? 0.5 : 1.0,

    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps

    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      // https://bugs.webkit.org/show_bug.cgi?id=246010
      /.*@webkit-masked-url:.* /,
      // GTM injected scripts
      /bat\.bing\.com\/p\/insights/i,
      // Branch.io related errors
      /cdn\.branch\.io\/branch-latest/i,
      // Translate google com related errors
      /translate\.google\.com\/translate_a/i,
      // Google tag manager
      /googletagmanager\.com\/gtag/i
    ],

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false
  })
}
